import type { ReactNode } from "react";

import type { RhfGroupWithProducts } from "@/src/domain/model/RhfGroup";

import { pathToProduct } from "@/src/app/paths";
import { ItemsAvailability } from "@/src/components/ui/ItemsAvailability";
import { ModalContent } from "@/src/components/ui/Modal/ModalContent";
import { Availability } from "@/src/domain/model/Availability";

interface RhfModalProps {
  readonly group: RhfGroupWithProducts;
}

export function RhfModal({ group }: RhfModalProps): ReactNode {
  const productsCount = group.products.length;
  return (
    <ModalContent
      description={
        productsCount > 1
          ? `${productsCount} produits référencés`
          : `${productsCount} produit référencé`
      }
      title={group.name}
      url={group.url}
    >
      <ItemsAvailability
        availability={Availability.HIGH}
        items={group.products.map((product) => ({
          href: pathToProduct(product),
          id: product.id,
          image: product.packImage,
          name: product.name,
        }))}
        title={group.description}
      />
    </ModalContent>
  );
}
